import axios from 'axios'
import Utils from '../services/Utils'

axios.defaults.timeout = 300000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
Utils.updateAuthorization()


export default {
    getStrings(callback) {
        axios.get(axios.defaults.ptApiUrl + 'translations?lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization,
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getUser(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'user?filter={"pt_id": ' + window.ptId + ',"id": ' + data.id + '}&photo=0&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': axios.defaults.authorization
            }
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    updateUser (data, callback) {
        axios.patch(axios.defaults.ptApiUrl + 'user?id=' + window.clientId + '&pt_id=' + window.ptId + '&website=1&lng=' + window.language,
            data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
}
